// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.XhmRl{bottom:0;left:0;pointer-events:none;position:absolute;right:0;top:0;z-index:1}.HSrXZ{top:unset}.L6gFe{display:-webkit-box;display:flex;pointer-events:none}.EOnS3{-webkit-box-pack:center;justify-content:center;-webkit-box-align:center;align-items:center;background:hsla(0,0%,100%,.6);height:100%}.b1BZo{-webkit-box-pack:end;justify-content:flex-end;-webkit-box-align:end;align-items:flex-end;height:100%}.fM2QM{-webkit-box-pack:start;justify-content:flex-start}.JumaG{background:#fff;color:#202626;font-family:Inter,sans-serif;font-size:.875rem;font-weight:400;letter-spacing:0;line-height:1.35;pointer-events:none}.jejSe{border-radius:4px;-webkit-box-shadow:0 0 8px rgba(0,0,0,.15);box-shadow:0 0 8px rgba(0,0,0,.15);padding:10px 18px}.Rgsat{background:hsla(0,0%,100%,.85);border-radius:.5rem 0 0;padding:.5rem 1rem}.UbLQB{border-radius:0;color:#202626;font-family:Inter,sans-serif;font-size:.75rem;font-weight:400;letter-spacing:0;line-height:1.35;padding:.5rem 1rem;text-align:center;width:100%}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `XhmRl`,
	"root_popup": `HSrXZ`,
	"overlay": `L6gFe`,
	"overlay_full": `EOnS3`,
	"overlay_offset": `b1BZo`,
	"overlay_popup": `fM2QM`,
	"callout": `JumaG`,
	"callout_full": `jejSe`,
	"callout_offset": `Rgsat`,
	"callout_popup": `UbLQB`
};
module.exports = ___CSS_LOADER_EXPORT___;
